export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorMaxCaracteres = (value,longitud = 5) => {
  if(value.length > longitud){
    return false;
  }
  return true;

}


export const validatorPassword = password => {
  // Debe contener al menos:
  // - una minúscula (a-z)
  // - una mayúscula (A-Z)
  // - un dígito (0-9)
  // - un caracter especial de este conjunto exacto: @ # $ % & / ( ) = + ? [ ] ~ – ^
  //   Nota: se incluye "/" escapado, los corchetes escapados, y el símbolo – (en dash Unicode) tal como fue solicitado.
  // - longitud mínima 8 (se mantiene el criterio previo). Ajustar si se requiere otro mínimo.
  if (typeof password !== 'string') return false
  /* eslint-disable no-useless-escape */
  const regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%&\/()=+?\[\]~–^]).{8,}$/
  /* eslint-enable no-useless-escape */
  return regExp.test(password)
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validarCorreo = (email) => {
  return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(email));
}


export const montoMax = (value,args) => {
  return value <= args.monto
}

export const required_array_content = (value) => {
  if(typeof value !== 'object' || value === null) return false;
  return value.length > 0 ? true : false;
}


